module.exports = __webpack_public_path__ + "img/ic_fitnessplan_serie.ebe70cef.svg";